export default __webpack_public_path__ + "static/media/logo.5b0d5d24.svg";